import Vue from 'vue'

const truncate = (text, stop = 100, clamp = '...') => {
	return text.slice(0, stop) + (stop < text.length ? clamp : '')
}

Vue.filter('truncate', truncate)
